// extracted by mini-css-extract-plugin
module.exports = {"controlsTitle":"_1XNU56G4HzkZAr3-0X0f9u","controlsList":"TPDznyqVwLlphXJ2ncmna","controlsListRow":"_1CoC7j0kuyzEVhwp1syK04","addControlBtn":"_2X6VXGTNqu3AvfhUsyobJZ"};